// Phase II · Wave D.6b · M14 legacy locale adapter.
//
// Phase II · Wave E.1c.4 · TD6 · DEPRECATED.
// The M14 legacy surface (``glms_lang`` cookie / localStorage) is now
// opt-in behind ``isM14LegacyEnabled()`` (default ``false``). When the
// flag is off:
//   · ``mapWaveDtoM14`` returns the input locale unchanged (passthrough)
//   · ``getLegacyLocale`` ignores the ``glms_lang`` sources entirely
//     and returns only the canonical Wave D ``glms_locale`` cookie, or
//     ``"en"`` as the ultimate fallback.
//
// The 40→15 mapping table is retained here (unused when flag off) so
// that re-arming the flag yields identical pre-TD6 behaviour.
import Cookies from "js-cookie";

import { isM14LegacyEnabled } from "@/i18n/m14_feature_flag";

const M14_ALLOWLIST = new Set([
    "en", "it", "es", "fr", "de", "pt", "nl", "pl", "tr",
    "ja", "zh-CN", "ru", "ar", "ko", "hi",
]);

// Explicit remaps where strip-region is not enough.
const EXPLICIT_MAP = {
    "en-US": "en",
    "pt-BR": "pt",
    "zh-CN": "zh-CN",
};

/**
 * Map a Wave D locale (40-set) to the M14 allowlist (15-set).
 *
 * Phase II · Wave E.1c.4 · TD6 · When ``isM14LegacyEnabled()`` is
 * ``false`` (default post-D.6b) the function returns the input locale
 * unchanged · callers that still invoke this adapter remain safe.
 */
export function mapWaveDtoM14(locale) {
    if (!isM14LegacyEnabled()) {
        return locale || "en";
    }
    if (!locale || typeof locale !== "string") return "en";
    const s = locale.trim();
    if (!s) return "en";
    if (EXPLICIT_MAP[s]) return EXPLICIT_MAP[s];
    const base = s.split("-")[0];
    if (M14_ALLOWLIST.has(base)) return base;
    return "en";
}

/**
 * Read the effective M14 locale from the canonical sources.
 *
 * When the legacy flag is off, we return only the canonical Wave D
 * cookie (``glms_locale``) or ``"en"``. The ``glms_lang`` cookie and
 * ``localStorage`` sources are intentionally NOT consulted.
 */
export function getLegacyLocale() {
    try {
        const waveD = Cookies.get("glms_locale");
        if (waveD) {
            return mapWaveDtoM14(waveD);
        }
    } catch { /* storage disabled */ }
    if (!isM14LegacyEnabled()) {
        return "en";
    }
    try {
        const legacy = Cookies.get("glms_lang");
        if (legacy && M14_ALLOWLIST.has(legacy)) return legacy;
    } catch { /* noop */ }
    try {
        if (typeof window !== "undefined" && window.localStorage) {
            const ls = window.localStorage.getItem("glms_lang");
            if (ls && M14_ALLOWLIST.has(ls)) return ls;
        }
    } catch { /* storage disabled */ }
    return "en";
}

/**
 * Return the raw cookie trio for diagnostics / tests.
 */
export function readCookieState() {
    const glms_locale = Cookies.get("glms_locale") || null;
    const glms_lang   = isM14LegacyEnabled()
        ? (Cookies.get("glms_lang") || null)
        : null;
    return {
        glms_locale,
        glms_lang,
        resolved_m14:   getLegacyLocale(),
        m14_legacy_enabled: isM14LegacyEnabled(),
    };
}
